import React, { useEffect, useState } from 'react';
import { Grid, Segment, Table, Popup, Icon, Header } from 'semantic-ui-react';
import { servicesAPI } from '../../_services';
import './Overview.css';

export const Overview = () => {
  const [liveData, setLiveData] = useState(null);
  const [refreshDate, setRefreshDate] = useState(null);

  useEffect(() => {
    servicesAPI
      .AdminServices('getMatrixRefreshDate', 'OPS')
      .then(refreshDate => {
        setRefreshDate(refreshDate[0]);
      });

    servicesAPI.AdminServices('getMatrixLiveData').then(liveData => {
      setLiveData(liveData);
    });
  }, []);

  const refreshDateTime = refreshDate ? refreshDate.refresh_datetime : '';

  const displayDataRow = row => [
    row
      ? row.map((d, idx) => (
          <Table.Cell
            collapsing
            style={{ textAlign: 'center' }}
            className={
              d.status === 'Stopped'
                ? d.cp_display_status + 'Muted'
                : d.cp_display_status
            }
          >
            {d.tag_status !== 'INACTIVE' && (
              <Popup
                wide
                content={
                  <div>
                    <p></p>
                    <p>
                      Status:{' '}
                      {d.cp_display_status === 'dbCellError' ? (
                        <span color="red">{d.system_state}</span>
                      ) : (
                        d.system_state
                      )}
                    </p>
                    <p>Status since: {d.log_datetime}</p>
                    <p>Last Heartbeat: {d.last_heartbeat_datetime}</p>
                    <p>Cartridge Serial No: {d.cart_serial_no}</p>
                    <p>Cartridge Install Date: {d.cart_install_datetime}</p>
                    <p>Sump Pump Installed: {d.sump_pump_installed} </p>
                    <p>Flood: {d.flood === true ? 'Y' : 'N'}</p>
                    <p>Muted: {d.status === 'Stopped' ? 'Y' : 'N'} </p>
                    <p>Capped: {d.status === 'Capped' ? 'Y' : 'N'}</p>
                    <p>Last Session: {d.last_session_datetime}</p>
                    <p>Total Sessions: {d.no_of_sessions}</p>
                    <p>Total Consumpion (kWh): {d.total_consumption_kwh}</p>
                  </div>
                }
                key={d.street + '|' + d.cs}
                header={d.street + ' - ' + d.cs}
                trigger={
                  <Icon
                    name={
                      d.status === 'Capped'
                        ? 'square'
                        : d.flood === true
                        ? 'tint'
                        : d.status === 'Isolated'
                        ? 'circle'
                        : d.system_state === 'Idling'
                        ? 'circle'
                        : d.system_state === 'EvC2'
                        ? 'lightning'
                        : d.system_state === 'EvB2'
                        ? 'plug'
                        : d.system_state === 'EvB1'
                        ? 'clock'
                        : d.system_state === 'WaitingPoleRaised'
                        ? 'warning'
                        : d.system_state === 'WaitingPoleDropped'
                        ? 'warning'
                        : d.system_state === 'EvInitial'
                        ? 'warning'
                        : d.system_state === 'BootingRejected'
                        ? 'stop circle'
                        : 'warning sign'
                    }
                  />
                }
              />
            )}
          </Table.Cell>
        ))
      : [{}]
  ];

  const displayData = liveDataCS => [
    liveDataCS
      ? liveDataCS
          .filter(
            (v, i, a) =>
              a.findIndex(v2 => ['street'].every(k => v2[k] === v[k])) === i
          )
          .map(d => (
            <Table.Row key={d.reference}>
              <Table.Cell
                className="dbRowHeader"
                onClick={() => {
                  const hubRef = d.reference.split('_cs_')[0];
                  document.location.href = `/admin/hubs/${hubRef}`;
                }}
              >
                {d.street}
              </Table.Cell>
              {displayDataRow(liveDataCS.filter(c => c.street === d.street))}
            </Table.Row>
          ))
      : [{}]
  ];

  if (!liveData || !refreshDate) return <div>Loading...</div>;

  return (
    <Segment>
      <Grid centered>
        <Grid.Row>
          <Grid.Column>
            <Header as="h2">HUB Overview</Header>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <br />
      Last Refreshed: {refreshDateTime}
      <br />
      <br />
      <Grid centered>
        <Grid.Row>
          <Grid.Column>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={3}>Street</Table.HeaderCell>
                  <Table.HeaderCell>CS01</Table.HeaderCell>
                  <Table.HeaderCell>CS02</Table.HeaderCell>
                  <Table.HeaderCell>CS03</Table.HeaderCell>
                  <Table.HeaderCell>CS04</Table.HeaderCell>
                  <Table.HeaderCell>CS05</Table.HeaderCell>
                  <Table.HeaderCell>CS06</Table.HeaderCell>
                  <Table.HeaderCell>CS07</Table.HeaderCell>
                  <Table.HeaderCell>CS08</Table.HeaderCell>
                  <Table.HeaderCell>CS09</Table.HeaderCell>
                  <Table.HeaderCell>CS10</Table.HeaderCell>
                  <Table.HeaderCell>CS11</Table.HeaderCell>
                  <Table.HeaderCell>CS12</Table.HeaderCell>
                  <Table.HeaderCell>CS13</Table.HeaderCell>
                  <Table.HeaderCell>CS14</Table.HeaderCell>
                  <Table.HeaderCell>CS15</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>{displayData(liveData)}</Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};
